import React from 'react'
// @ts-ignore
import { Avatar, Skeleton, DefaultAvatar } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import Link from 'components/visualization/MediaModal/Link'

interface AuthorAvatarProps {
  isRetweet?: boolean
  data: {
    authorName?: string
    authorHandle?: string
    authorAvatarUrl?: string
    authorUrl?: string
    originalAuthorName?: string
    originalAuthorHandle?: string
    originalAuthorAvatarUrl?: string
    originalAuthorUrl?: string
  }
}

const AuthorAvatar = ({ isRetweet, data }: AuthorAvatarProps) => {
  const theme = useDisplayTheme() as Theme

  const name = isRetweet ? data.originalAuthorName : data.authorName
  const handle = isRetweet ? data.originalAuthorHandle : data.authorHandle
  const avatarUrl = isRetweet ? data.originalAuthorAvatarUrl : data.authorAvatarUrl
  const url = isRetweet ? data.originalAuthorUrl : data.authorUrl

  const shouldUseCustomFallback = !name && !handle

  return (
    <Link href={url}>
      <Avatar
        mode={theme}
        variant="circular"
        alt={name || handle}
        diameter="32px"
        src={avatarUrl}
        loader={
          <Skeleton mode={theme} variation="circle" width="32px" height="32px" animation="wave" />
        }
        fallbackStyles={{ fontSize: '24px', fontWeight: 400, cursor: 'pointer' }}>
        {shouldUseCustomFallback ? <DefaultAvatar mode={theme} fontSize={48} /> : null}
      </Avatar>
    </Link>
  )
}

export default AuthorAvatar
